import { createClient } from '@supabase/supabase-js';

// 前端直连 Supabase：不再经过 Express 后端
// 配置项来自构建期环境变量（web/.env.development / .env.production）
const SUPABASE_URL = process.env.VUE_APP_SUPABASE_URL || 'https://avgqoglzafumghhrpjgh.supabase.co';
const SUPABASE_ANON_KEY =
  process.env.VUE_APP_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF2Z3FvZ2x6YWZ1bWdoaHJwamdoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODc5MzcxNjcsImV4cCI6MjEwMzUxMzE2N30.h58_RIUP4M2WN868fQ_uHABGbJwqCmUr1DvJq91QGRY';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storage: window.localStorage,
    storageKey: 'hs_admin_supabase_session',
  },
});

export const TOKEN_KEY = 'hs_admin_token';

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

// 页面刷新后恢复会话：刷新 token 并同步到本地存储
export async function restoreSession() {
  try {
    const { data } = await supabase.auth.getSession();
    if (data?.session?.access_token) {
      setToken(data.session.access_token);
      return data.session.user;
    }
    const { data: refreshed } = await supabase.auth.refreshSession();
    if (refreshed?.session?.access_token) {
      setToken(refreshed.session.access_token);
      return refreshed.session.user;
    }
  } catch (e) {
    /* 未登录 */
  }
  setToken(null);
  return null;
}

export async function logout() {
  try {
    await supabase.auth.signOut();
  } catch (e) {
    /* ignore */
  }
  setToken(null);
}
